export default "/assets/error.svg";